<template>
    <div class="webglContainer" style="overflow:hidden">
        <div id="webgl" ref="webgl"></div>
        <div v-if="!isDevices" class="rightBtns">
          <div class="btns">
            <div v-if="sceneInfos.vr == 1" class="btn vrBtn" @click="goVR()">
              <i></i>
            </div>
          </div>
        </div>
        <div v-if="isDevices" class="exitVrBtn" @click="exitVr()">
            退出VR模式
        </div>
        <div v-if="!isDevices" class="leftBottomBar">
          <div class="btns">
            <div :class="['btn', leftBtnActiveNum === 1?'active':'']" @click="playPano()">
              <img src="images/play.png" alt="" srcset="">
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls, MapControls } from 'three/examples/jsm/controls/OrbitControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
import { DeviceOrientationControls } from 'three/examples/jsm/controls/DeviceOrientationControls.js'
import { StereoEffect } from 'three/examples/jsm/effects/StereoEffect'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import zcfCommon from '../../public/com/zcf_common'
import https from '../https.js'

let vm = null
const vertexShader = [
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    pPos = position;',
  '    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );',
  '    gl_Position = projectionMatrix * mvPosition;',
  '}'
].join('\n')

const fragmentShader = [
  '#ifdef GL_ES',
  '    precision highp float;',
  '#endif',
  'const float PI = 3.1415926;',
  'const float TWO_PI = 6.2831852;',

  'uniform samplerCube texture;',
  'uniform vec3 cPosition;',
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    vec3 np = normalize(pPos-cPosition);',
  '    gl_FragColor = textureCube( texture, vec3(np.x,np.y,-np.z ));',
  '}'
].join('\n')

// import VConsole from 'vconsole'
// const vConsole = new VConsole() //注意
export default {
  components: {
  },
  data: () => {
    return {
      modelID: '',
      tipImgSrc: '',
      annie: [],
      aniMap: null,
      tipShow: false,
      canControl: false,
      loading: true,
      daping: null,
      video: null,
      resInfos: {},
      nowActivePano: 0,
      leftBtnActiveNum: 3,
      modelData: {},
      preMats: {},
      listIsShow: false,
      hotPointMaps: {},
      hPTypeArr: [],
      sceneInfos: {
        vr: 0,
        viewSwitch: 0
      },
      isEffect: false,
      isDevices: false,
      isChanged: false,
      picTipShow: false,
      picData: {},
      audioBgPlay: false
    }
  },
  created () {
    this.sceneID = this.$route.query.id
    console.log(this.sceneID)
    vm = this
    https.fetchPost('/api/HotPoint/GetlistByPyFile_Scene_ID_2', {
      sceneID: this.sceneID
    }).then(res => {
      if(res.status === 200) {
        document.title = res.data[0].scene.sceneName
        var m = {}
        m = res.data[0].scene
        m.model = res.data[0].model
        m.switchs = res.data[0].switchs
        m.panos = []
        for(var i = 0; i < res.data[0].result.length; i++) {
          var k = {}
          k.physicalFile = res.data[0].result[i].physicalFile
          k.hotPointlist = res.data[0].result[i].hotPointlist
          for(var key in res.data[0].result[i].physicalFile_Scene) {
            k[key] = res.data[0].result[i].physicalFile_Scene[key]
          }
          m.panos.push(k)
        }
        this.resInfos = m
        console.log(this.resInfos)
        this.sceneInfos.vr = this.resInfos.switchs.vr
        this.sceneInfos.viewSwitch = this.resInfos.switchs.viewSwitch
        this.nowPanoName = this.resInfos.panos[0].physicalFile.fileName
        this.init()
        this.animate()
      }
    })
  },
  mounted () {
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.pmremGenerator = null
    this.isDown = false
    this.isMoving = false
    this.isModelShow = false
    this.panoGroup = new THREE.Group()
    this.markGroup = new THREE.Group()
    this.fingers = null
    this.onPointerDownPointerX = 0
    this.onPointerDownPointerY = 0
    this.onPointerDownLon = 0
    this.onPointerDownLat = 0
    this.onPointerDownPointerX0 = 0
    this.onPointerDownPointerY0 = 0
    this.onPointerDownPointerX1 = 0
    this.onPointerDownPointerY1 = 0
    this.preMoveX = 0
    this.preMoveY = 0
    this.offX = 0
    this.offY = 0
    this.disFinger = 0
    this.lon = 270
    this.lat = 0
    this.phi = 0
    this.theta = 0
    this.canDamp = false
    this.dampingFactor = 0.2
    this.targetBox = null
    this.hasLoaded = false
    this.planeUniforms = null
    this.preV = new THREE.Vector2()
    this.nowPanoName = ''
    this.textrueLoader = new THREE.TextureLoader()
    this.clock = new THREE.Clock()
    this.planeMat = null
    this.mousePoint = null
    this.endPoint = null
    this.Devices = null
    this.effect = null
    this.hotTexture1 = null
  },
  methods: {
    playPano() {
      this.video.play()
    },
    exitVr() {
      this.isDevices = !this.isDevices
      if(window.innerWidth >= window.innerHeight) {
        this.isEffect = this.isDevices
      }else {
        this.isEffect = false
      }
    },
    goVR() {
      if(this.leftBtnActiveNum === 3) {
        if(this.Devices === null) {
          this.Devices = new DeviceOrientationControls(this.camera)
        }
        this.listIsShow = false
        this.isDevices = !this.isDevices
        if(window.innerWidth >= window.innerHeight) {
          this.isEffect = this.isDevices
          console.log('enterVR1' + this.isEffect)
        }else {
          this.isEffect = false
          console.log('enterVR2' + this.isEffect)
        }
        console.log(this.isDevices)
      }else{
        this.$message({
          message: '请在全景漫游模式下进入VR模式',
          type: 'warning'
        })
      }
    },
    getPanoIndexByName(name) {
      var num = -1
      for(var i = 0; i < this.resInfos.panos.length; i++) {
        if(this.resInfos.panos[i].physicalFile.fileName === name) {
          num = i
        }
      }
      return num
    },
    getPanoPathByName(name) {
      var arr = this.resInfos.panos.filter(item => {
        return item.physicalFile.fileName === name
      })
      return arr[0].physicalFile.filePath
    },
    // 场景初始
    init () {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.targetBox = new THREE.Mesh(
        new THREE.BoxBufferGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0
        })
      )
      this.scene.add(this.targetBox)
      this.scene.add(this.panoGroup)
      this.scene.add(this.markGroup)

      // this.aniMap = new THREE.TextureLoader().load('http://720.tour3c.com/imgs/details/Hotspot7_gif.png')
      // var textureAnimator = new this.TextureAnimator(this.aniMap, 1, 25, 25, 75)
      // this.annie.push(textureAnimator)
      this.camera = new THREE.PerspectiveCamera(
        70,
        this.containerW / this.containerH,
        10,
        999999
      )

      this.camera.position.set(0, 0, 0)
      // this.camera.position.set(0, this.panos[0].pos.y, 0)
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.camera.lookAt(this.targetBox.position)
      this.scene.add(this.camera)

      const ambientLight = new THREE.AmbientLight(0x888888)
      this.scene.add(ambientLight)

      const directionalLight = new THREE.DirectionalLight(0xffffff, 1.2)
      directionalLight.position.set(100, 100, 100)
      this.scene.add(directionalLight)

      const directionalLight01 = new THREE.DirectionalLight(0xffffff, 0.8)
      directionalLight01.position.set(-100, 0, -100)
      this.scene.add(directionalLight01)

      this.video = document.createElement('video')
      // video.width = 1000;
      // video.height = 500;
      this.video.loop = true
      this.video.currentTime = 1
      this.video.setAttribute('webkit-playsinline', 'webkit-playsinline')
      this.video.setAttribute('playsinline', 'playsinline')
      this.video.setAttribute('x-webkit-airplay', 'x-webkit-airplay')
      this.video.setAttribute('x5-video-player-type', 'h5')
      this.video.setAttribute('x5-video-player-fullscreen', 'true')
      this.video.setAttribute('src', this.resInfos.panos[0].physicalFile.filePath)

      var texture = new THREE.VideoTexture(this.video)
      texture.minFilter = THREE.LinearFilter
      texture.magFilter = THREE.LinearFilter
      texture.format = THREE.RGBFormat

      var material = new THREE.MeshBasicMaterial({ color: 0xffffff, map: texture })
      material.needsUpdate = true
      var ballMesh = new THREE.Mesh(new THREE.SphereBufferGeometry(1000, 64, 64), material)
      ballMesh.geometry.scale(-1, 1, 1)
      this.scene.add(ballMesh)
      this.canControl = true

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.containerW, this.containerH)

      this.container.appendChild(this.renderer.domElement)

      // this.Devices.connect()

      this.effect = new StereoEffect(this.renderer)
      this.effect.setSize(window.innerWidth, window.innerHeight)


      window.addEventListener('resize', this.onresize, false)
      this.renderer.domElement.addEventListener('mousedown', this.onRendererMouseDown, false)
      this.renderer.domElement.addEventListener('mousemove', this.onRendererMouseMove, false)
      this.renderer.domElement.addEventListener('mouseup', this.onRendererMouseUp, false)
      this.renderer.domElement.addEventListener('touchstart', this.onRendererTouchStart, false)
      this.renderer.domElement.addEventListener('touchmove', this.onRendererTouchMove, false)
      this.renderer.domElement.addEventListener('touchend', this.onRendererTouchEnd, false)
    },
    onRendererTouchStart(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.touches[0].pageX
      this.preV.y = event.touches[0].pageY
      if (event.touches.length === 1) {
        this.fingers = 1
        this.preMoveX = this.onPointerDownPointerX = event.touches[0].pageX
        this.preMoveY = this.onPointerDownPointerY = event.touches[0].pageY
        this.onPointerDownLon = this.lon
        this.onPointerDownLat = this.lat
      } else if (event.touches.length === 2) {
        this.fingers = 2
        this.onPointerDownPointerX0 = event.touches[0].pageX
        this.onPointerDownPointerY0 = event.touches[0].pageY
        this.onPointerDownPointerX1 = event.touches[1].pageX
        this.onPointerDownPointerY1 = event.touches[1].pageY
        this.disFinger = Math.sqrt(
          Math.pow(
            this.onPointerDownPointerX1 - this.onPointerDownPointerX0,
            2
          ) +
            Math.pow(
              this.onPointerDownPointerY1 - this.onPointerDownPointerY0,
              2
            )
        )
      }
    },
    onRendererTouchMove(event) {
      event.preventDefault()
      if (this.canControl) {
        this.isMoving = true
        if (event.touches.length === 1 && this.fingers === 1) {
          this.lon =
            (this.onPointerDownPointerX - event.touches[0].pageX) * 0.3 +
            this.onPointerDownLon
          this.lat =
            (event.touches[0].pageY - this.onPointerDownPointerY) * 0.3 +
            this.onPointerDownLat
          this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
          this.offX = event.touches[0].pageX - this.preMoveX
          this.offY = event.touches[0].pageY - this.preMoveY
          this.preMoveX = event.touches[0].pageX
          this.preMoveY = event.touches[0].pageY
        } else if (event.touches.length === 2 && this.fingers === 2) {
          event.preventDefault()
          this.onPointerDownPointerX0 = event.touches[0].pageX
          this.onPointerDownPointerY0 = event.touches[0].pageY
          this.onPointerDownPointerX1 = event.touches[1].pageX
          this.onPointerDownPointerY1 = event.touches[1].pageY
          var disFingerNow = Math.sqrt(
            Math.pow(
              this.onPointerDownPointerX1 - this.onPointerDownPointerX0,
              2
            ) +
              Math.pow(
                this.onPointerDownPointerY1 - this.onPointerDownPointerY0,
                2
              )
          )
          var ratio = (disFingerNow - this.disFinger) / this.disFinger
          if (ratio < 0) {
            if (this.camera.fov <= 60) {
              this.camera.fov = (1 - ratio) * this.cameraFov
              this.camera.updateProjectionMatrix()
            }
          } else {
            if (this.camera.fov >= 20) {
              this.camera.fov = (1 - ratio * 0.15) * this.cameraFov
              this.camera.updateProjectionMatrix()
            }
          }
        }
      }
    },
    onRendererTouchEnd(event) {
      var upV = new THREE.Vector2(
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
      )
      if (this.canControl) {
        if (this.fingers === 1) {
          this.canDamp = true
        }
        this.fingers = 0
        this.cameraFov = this.camera.fov
        this.isMoving = false
      }
    },
    onRendererMouseDown(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.clientX
      this.preV.y = event.clientY
      this.preMoveX = this.onPointerDownPointerX = event.clientX
      this.preMoveY = this.onPointerDownPointerY = event.clientY
      this.onPointerDownLon = this.lon
      this.onPointerDownLat = this.lat
    },
    onRendererMouseMove(event) {
      event.preventDefault()
      this.isMoving = true
      if (this.isDown) {
        if (this.leftBtnActiveNum !== 4 && this.leftBtnActiveNum !== 5) {
          this.lon =
            (this.onPointerDownPointerX - event.clientX) * 0.15 +
            this.onPointerDownLon
          this.lat =
            (event.clientY - this.onPointerDownPointerY) * 0.15 +
            this.onPointerDownLat
          this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
          this.offX = event.clientX - this.preMoveX
          this.offY = event.clientY - this.preMoveY
          this.preMoveX = event.clientX
          this.preMoveY = event.clientY
        }
      } else {
      }
    },
    onRendererMouseUp() {
      if (this.canControl) {
        this.canDamp = true
      }
      this.isMoving = false
      this.isDown = false
    },
    getMinPoint(arr, pos) {
      var name = ''
      var dis = Infinity
      for (var i = 0; i < arr.length; i++) {
        var nextPos = new THREE.Vector3(arr[i].posX, 0, arr[i].posZ)
        var nowDis = pos.distanceTo(nextPos)
        // console.log(pos);
        // console.log(nextPos);
        // console.log(nowDis);
        if(nowDis < dis) {
          dis = nowDis
          name = arr[i].physicalFile.fileName
        }
      }
      return name
    },
    posObj(obj, cam, r, lon, lat, h) {
      lat = Math.max(-85, Math.min(85, lat))
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(lon)
      obj.position.x = r * Math.sin(phi) * Math.cos(theta) + cam.position.x
      obj.position.y = r * Math.cos(phi) + cam.position.y
      obj.position.z = r * Math.sin(phi) * Math.sin(theta) + cam.position.z
    },
    // 窗口改变
    onresize () {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
      this.effect.setSize(this.containerW, this.containerH)
      if(window.innerWidth >= window.innerHeight) {
        this.isEffect = this.isDevices
      }else {
        this.isEffect = false
      }
    },
    // 循环渲染
    render() {
      if(this.isDevices && this.isEffect) {
        this.effect.render(this.scene, this.camera)
        if(!this.isChanged) {
          this.effect.setSize(window.innerWidth, window.innerHeight)
          this.isChanged = true
        }
      }else{
        this.renderer.render(this.scene, this.camera)
        if(this.isChanged) {
          this.renderer.setSize(window.innerWidth, window.innerHeight)
          this.isChanged = false
        }
      }
    },
    animate () {
      var delta = this.clock.getDelta()
      TWEEN.update()
      if (!this.isDevices) {
        if (this.canDamp) {
          this.offX *= 1 - this.dampingFactor
          this.offY *= 1 - this.dampingFactor
          if (Math.abs(this.offX) <= 0.01) {
            this.offX = 0
          }
          if (Math.abs(this.offY) <= 0.01) {
            this.offY = 0
          }
          if (this.offX === 0 && this.offX === 0) {
            this.canDamp = false
          }
          this.lon -= this.offX
          if (this.lat <= 85) {
            this.lat += this.offY
          }
          this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
        }
        this.camera.lookAt(this.targetBox.position)
      } else {
        console.log(1)
        this.Devices.update()
      }
      this.rafId = requestAnimationFrame(this.animate)
      this.render()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onresize, false)
    cancelAnimationFrame(this.rafId)
    this.renderer.dispose()
    this.renderer.forceContextLoss()
    // this.renderer.context = null
    this.renderer.domElement = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.rafId = null
    this.container = null
    this.mesh = null
    this.controls = null
    this.modelInfo = null
  }
}
</script>
<style scoped>
  .webglContainer{
    width: 100%;
    height: 100%;
    position: relative;
    background-color:#ffffff;
  }
  #webgl{
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .audioBg{
    width:0;
    height:0;
    position: absolute;
    left: -100;
    top:-100;
  }
  .audioSay{
    width:0;
    height:0;
    position: absolute;
    left: -100;
    top:-100;
  }
  .exitVrBtn{
    width: 100px;
    height: 30px;
    position: absolute;
    left: 50%;
    margin-left: -50px;
    line-height:30px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    background-color: rgba(0,0,0,0.5);
    border-radius: 2px 2px;
  }
  .rightBtns{
    width:31px;
    height:auto;
    position: absolute;
    right:14px;
    top:14px;
  }
  .rightBtns .btns{
    position:relative;
  }
  .rightBtns .btn{
    width:31px;
    height:31px;
    position:relative;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .rightBtns .btn i{
    display: block;
    width:62px;
    height:62px;
    background-image: url("../../public/images/btnBg.png");
    transform-origin: 0 0;
    transform: scale(0.5);
  }
  .rightBtns .btn.vrBtn i{
    background-size: 900px 1009px;
    background-position: 0px -590px;
  }
  .rightBtns .btn.audioBtn i{
    background-size: 900px 1009px;
    background-position: -130px -590px;
  }
  .rightBtns .btn.audioBtn.active i{
    background-size: 900px 1009px;
    background-position: -130px -660px;
  }
  .rightBtns .btn.viewChangeBtn i{
    background-size: 900px 1009px;
    background-position: -325px -660px;
  }
  .leftBottomBar{
    width: auto;
    height: auto;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .leftBottomBar .btns{
    position: relative;
    display: flex;
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    height: 48px;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.5));
  }
  .leftBottomBar .btns .btn{
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 48px;
    flex: 0 0 48px;
    position: relative;
    cursor: pointer;
  }
  .leftBottomBar .btns .btn img{
    width: 48px;
    height: 48px;
    opacity: 0.3;
  }
  .leftBottomBar .btns .btn.active img{
    opacity: 1.0;
  }
  .thumbPicWrap{
    width: 100%;
    height: 100px;
    position: absolute;
    bottom: 48px;
    background-color: rgba(0,0,0,0.5);
    text-align: center;
  }
  .thumbPicWrap .scrollWrap {
    position: relative;
    width: calc(100vw - 0px);
    height:auto;
    height:100px;
  }
  .thumbPicWrap .thumbPicList{
    height:100px;
    margin-top:10px;
    position: relative;
    display: flex;
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
  }
  .thumbPicWrap .thumbPicList div{
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 80px;
    flex: 0 0 80px;
    position: relative;
    cursor: pointer;
    margin-left: 5px;
    margin-right: 5px;
    height:80px;
  }
  .thumbPicWrap .thumbPicList div span{
    display: inline-block;
    width: 74px;
    height: 16px;
    text-align: center;
    background-color: rgba(0,0,0,0.5);
    color:white;
    position: absolute;
    left: 3px;
    bottom: 3px;
    font-size: 12px;
    line-height: 16px;
  }
  .thumbPicWrap .thumbPicList img{
    height:80px;
    border-width: 3px;
    border-style: solid;
    border-color: #fff;
    box-sizing: border-box;
  }

  .thumbPicWrap .thumbPicList div.active img{
    border-color: #f6b64c;
  }
</style>
